import { AssetType, Loan, Product, Program } from '@nemuru-eng/js-api-client';

import { CardConditionsData } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LoanConditions/components/CardConditionsData';
import { CreditLineNoPurchase } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LoanConditions/components/CreditLineNoPurchase';
import { LoanConditionsData } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LoanConditions/components/LoanConditionsData';
import { LoanConditionsEntity } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LoanConditions/entities/LoanConditionsEntity';

const LoanConditionsDataDisplay = ({ loan }: { loan: Loan }) => {
  const product = loan.loanConditions.product;
  const loanConditions = new LoanConditionsEntity(loan);

  const assetType = loan.assetReference[0].type;
  const programName = loan.loanConditions.program.name;

  const getProductNameByAssetTypeAndProgram = () => {
    if (assetType === AssetType.ORDER) {
      switch (programName) {
        case Program.ZERO_PROGRAM:
          return 'SPLIT_PAY';
        case Program.FREE_PROGRAM:
          return 'INSTALMENTS';
      }
    }
    switch (product) {
      case Product.CREDIT_LINE:
        return 'CREDIT_LINE_WITH_PURCHASE';
      case Product.CONSUMER_LOAN:
      case Product.AUTO:
      default:
        return loanConditions.annualInterest ? 'WITH_ANNUAL_INTERESTS' : 'NO_ANNUAL_INTERESTS';
    }
  };

  if (product === Product.CREDIT_LINE && programName === Program.NO_PURCHASE) {
    return <CreditLineNoPurchase loanConditions={loanConditions} />;
  }

  if (assetType === AssetType.CARD) {
    return <CardConditionsData loan={loan} />;
  }

  return <LoanConditionsData loanConditions={loanConditions} productName={getProductNameByAssetTypeAndProgram()} />;
};

export { LoanConditionsDataDisplay };
